import { countBy } from './countBy';
import { filterDuplicateCancelledPaxsByGreatestRevisions } from './filterDuplicateCancelledPaxsByGreatestRevisions';

export const legsAndProductsWithoutDuplicates = ({ legs = [] }) => {
  const countsService = countBy({ data: legs, dataKey: 'serviceType.code' });
  const duplicateTrains = legs.filter(({ serviceType }) => countsService[serviceType?.code] > 1);

  if (duplicateTrains.length || legs.length === 1) {
    const productsFromLegs = legs.flatMap(({ products }) => products ?? []);
    const countsPassengers = countBy({ data: productsFromLegs, dataKey: 'passengerId' });
    const duplicatePassengers = productsFromLegs.filter(({ passengerId }) => passengerId && countsPassengers[passengerId] > 1);

    if (duplicatePassengers.length) {
      const duplicatePaxsIds = duplicatePassengers.flatMap(({ passengerId }) => passengerId);
      const filteredLegs = legs
        .map(({ products, bookingItems, ...rest }) => ({
          products: products?.filter(({ cancelled, passengerId, createdRevision, cancelledRevision }) =>
            duplicatePaxsIds.includes(passengerId)
              ? filterDuplicateCancelledPaxsByGreatestRevisions({
                  duplicatePassengersProducts: duplicatePassengers?.filter((i) => i.passengerId === passengerId),
                  cancelled,
                  createdRevision,
                  cancelledRevision
                })
              : true
          ),
          bookingItems: bookingItems?.filter(({ cancelled, passengerId, createdRevision, cancelledRevision }) =>
            duplicatePaxsIds.includes(passengerId)
              ? filterDuplicateCancelledPaxsByGreatestRevisions({
                  duplicatePassengersProducts: duplicatePassengers?.filter((i) => i.passengerId === passengerId),
                  cancelled,
                  createdRevision,
                  cancelledRevision
                })
              : true
          ),
          ...rest
        }))
        ?.filter(({ products }) => products?.length);

      return filteredLegs?.length ? filteredLegs : legs;
    }

    return legs;
  }

  return legs;
};
